import React from 'react';
import clsx from 'clsx';

export interface ScreenImageProps {
  imageUrl: string;
  altText: string;
  className?: string;
  /** Load eagerly (e.g. above-the-fold hero). Defaults to lazy loading. */
  eager?: boolean;
}

/**
 * Frameless app concept image.
 * App concept assets already include their own device artwork, so we render them
 * inside a clean 9:16 container (radius-lg, hairline border) instead of wrapping
 * them in a second CSS device bezel.
 */
export const ScreenImage: React.FC<ScreenImageProps> = ({
  imageUrl,
  altText,
  className,
  eager = false,
}) => {
  return (
    <div
      className={clsx(
        'relative w-full aspect-[9/16] overflow-hidden rounded-lg border border-slate-200/80 bg-slate-50',
        className
      )}
    >
      <img
        src={imageUrl}
        alt={altText}
        className="absolute inset-0 w-full h-full object-cover object-top"
        loading={eager ? 'eager' : 'lazy'}
        decoding="async"
      />
    </div>
  );
};
